import mixpanel from "@/ems/mixpanel";
import { userSessionStore } from "@/store/user_session";

export const useMixPanelEvent = () => {
  const user_session = userSessionStore();
  const trackEvent = async (eventName: string, properties?: Record<string, any>) => {
    mixpanel
      .getMixpanelImpl(user_session.logged_user)
      .then((mpEvent) => mpEvent && mpEvent.track(eventName, properties));
  };

  return {
    trackEvent,
  };
};
